import { reducers, productStatusActions } from './storeChunk'

export default {
  reducers,
  actions: { productStatusActions },
}
